import { COUNTY_ACTIONS } from 'state/actions';
export const initialState = { loading: false, values: [] };

const countyReducer = (
  state = initialState,
  { type, data: { counties, loading } = { counties: [], loading: false } },
) => {
  switch (type) {
    case COUNTY_ACTIONS.COUNTIES_LOADING_SET: {
      return { ...state, loading };
    }
    case COUNTY_ACTIONS.COUNTIES_RETRIEVED: {
      return { ...state, values: counties };
    }
    default:
      return state;
  }
};

export default countyReducer;
